export const formatThousand = (number, decimals=2) => {
    return number.toLocaleString(undefined, {minimumFractionDigits:decimals, maximumFractionDigits:decimals});
}